import { gql } from '@apollo/client'

export type TimeInterval = 'hour' | 'day'

export type Filters = {
  includeNonCompletionActivities: boolean
  includeCompletionActivities: boolean
}

export type QueryVars = {
  userId: string
  customerId: string
  startDate: string
  endDate: string
  filters?: Filters
  timeInterval: TimeInterval
}

export type DateTotalActivitiesResponse = {
  date: string
  totalActivities: number
}

export type Response = {
  getTotalActivitiesByDateForUser: DateTotalActivitiesResponse[]
}

const query = gql`
  query (
    $userId: String!
    $customerId: String!
    $startDate: String!
    $endDate: String!
    $filters: GetTotalActivitiesByDateForUserFilters
    $timeInterval: TimeInterval!
  ) {
    getTotalActivitiesByDateForUser(
      userId: $userId
      customerId: $customerId
      startDate: $startDate
      endDate: $endDate
      filters: $filters
      timeInterval: $timeInterval
    ) {
      date
      totalActivities
    }
  }
`

export default query
